/**
 *  author: Patrick Vyn Badiang
 *
 * Description:
 * is the footer of the page, contains the socials
 *
 */


import { Box, Link, Typography } from "@mui/material";
import facebookV from '../pictures/icons/facebook-v.png';
import instagramV from '../pictures/icons/instagram-v.png';
import youtubeV from '../pictures/icons/youtube-v.png';
import venmoV from '../pictures/icons/venmo-v.png';
import spotifyV from '../pictures/icons/spotify-v.svg';

function BottomFooter() {

    const socials = [
        { name: 'Facebook', href: 'https://www.facebook.com/fasavirginiatech', icon: facebookV },
        { name: 'Instagram', href: 'https://www.instagram.com/vt_fasa/', icon: instagramV },
        { name: 'Youtube', href: 'https://www.youtube.com/VTFASAHokies', icon: youtubeV },
        { name: 'Venmo', href: 'https://account.venmo.com/u/VTFASA', icon: venmoV },
        { name: 'Spotify', href: 'https://open.spotify.com/user/fbmoh8wjcrxqrwfkm16jvpwpj?si=X5uZlP7fRxuD6-nJ3omA5A&utm_source=copy-link', icon: spotifyV },
    ];

    const linkSx = {
        display: 'flex',
        opacity: 1,
        transition: 'opacity 0.15s ease',
        '&:hover': {
            opacity: 0.75,
        },
    };

    return (
        <Box
            sx={{
                bgcolor: 'primary.main',
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '24px',
                px: { xs: '20px', sm: '48px' },
                py: '18px',
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    color: 'background.default',
                    letterSpacing: '1px',
                    fontSize: { xs: '1.1rem', sm: '1.3rem', md: '1.5rem', lg: '2rem' },
                }}
            >
                FASA at VT
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '20px' }}>
                {socials.map((social) => (
                    <Link
                        key={social.name}
                        href={social.href}
                        target="_blank"
                        rel="noopener"
                        aria-label={social.name}
                        sx={linkSx}
                    >
                        <Box component="img" src={social.icon} alt="" sx={{ width: '26px', height: '26px' }} />
                    </Link>
                ))}
            </Box>
        </Box>
    );
}

export default BottomFooter;
